export function getUsageReport(readings, assets, clients) {
    const results = [];
    const assetMap = {};

    readings.forEach(reading => {
        const ts = reading.ts;
        reading.rows.forEach(row => {
            const { assetid, reading: value } = row;
            if (!assetMap[assetid]) {
                assetMap[assetid] = [];
            }
            assetMap[assetid].push({ ts, reading: parseFloat(value) });
        });
    });

    for (const assetid in assetMap) {
        const entries = assetMap[assetid].sort((a, b) => a.ts - b.ts);
        if (entries.length >= 2) {
            const first = entries[0].reading;
            const last = entries[entries.length - 1].reading;
            const usage = last - first;
            const asset = assets.find(a => a.id === assetid);
            const clientid = asset?.properties?.clientid;
            const type = asset?.properties?.type;
            let distributetoshares = asset?.properties?.distributetoshares == '1' ? true : false
            if (type == 'input' || (type == 'output' && distributetoshares)) continue;
            const clientname = clients.find(c => c.id === clientid)?.name || 'Unknown';
            results.push({ clientname: clientname, usage: usage });
        }
    }

    results.sort((a, b) => b.usage - a.usage);
    return results;
}

export function getReadingsData(context) {
    const {
        readings,
        assetid,
        fromts,
        tots
    } = context;

    let result = [];

    readings.sort((a, b) => a.ts - b.ts);

    let previous = null;
    readings
        .filter(tx => tx.ts >= fromts && tx.ts <= tots)
        .forEach(reading => {
            reading.rows.forEach(row => {
                if (row.assetid === assetid) {
                    const timestamp = parseInt(reading.ts);
                    const value = parseFloat(row.reading) || 0;
                    const diff = previous === null ? 0 : value - previous;

                    result.push({
                        ts: timestamp,
                        reading: Number(value.toFixed(2)),
                        difference: Number(diff.toFixed(2))
                    });
                    previous = value;
                }
            });
        });

    return result;
}

export function calculateConsumptionMeters(consumption, meters, beforeReading, afterReading) {
    consumption = parseFloat(consumption) || 0;
    let result = {};

    if (!beforeReading || !afterReading) return [];

    let totalShares = 0;
    let totalBefore = 0;
    let totalAfter = 0;
    let totalUsage = 0;
    let totalUsageInput = 0;
    let totalUsageOutput = 0;
    let totalImabalance = 0;
    let totalUsageToBeDistributed = 0;

    meters.map(asset => {
        let type = asset?.properties?.type;
        let share = parseFloat(asset?.properties?.share) || 0
        let before = parseFloat(beforeReading.rows.find(row => row.assetid === asset.id)?.reading || 0);
        let after = parseFloat(afterReading.rows.find(row => row.assetid === asset.id)?.reading || 0);
        let usage = after - before;
        let distributetoshares = asset?.properties?.distributetoshares;

        totalShares += share;
        totalBefore += before;
        totalAfter += after;
        totalUsage += usage;
        if (type == 'input') totalUsageInput += usage;
        if (type == 'output') totalUsageOutput += usage;
        if (distributetoshares) totalUsageToBeDistributed += usage;
    });

    let distributetosharesConsumption = 0;
    if (totalUsageInput == 0) {
        totalImabalance = 0;
        distributetosharesConsumption = consumption * ((totalUsageToBeDistributed + totalImabalance) / totalUsageOutput)
        console.log(distributetosharesConsumption)
    }
    else {
        totalImabalance = totalUsageInput - totalUsageOutput;
        distributetosharesConsumption = consumption * ((totalUsageToBeDistributed + totalImabalance) / totalUsageInput)
        console.log(distributetosharesConsumption)
    }

    let totalConsumptionDistributed = 0;
    let totalConsumptionShared = 0;
    let totalConsumptionTotal = 0;

    let metersResult = meters.map(asset => {
        let type = asset?.properties?.type;
        let distributetoshares = asset?.properties?.distributetoshares == '1' ? true : false
        let name = asset.name;
        let clientid = asset?.properties?.clientid;
        let share = parseFloat(asset?.properties?.share) || 0
        let before = parseFloat(beforeReading.rows.find(row => row.assetid === asset.id)?.reading || 0);
        let after = parseFloat(afterReading.rows.find(row => row.assetid === asset.id)?.reading || 0);
        let usage = after - before;

        let consumptiondistributed = 0;
        let consumptionshared = 0;
        let consumptiontotal = 0;

        if (type == 'output' && !distributetoshares) {
            consumptiondistributed = consumption * (usage / (totalUsageOutput + totalImabalance));
            consumptionshared = distributetosharesConsumption * (share / totalShares);
            consumptiontotal = consumptiondistributed + consumptionshared
        }

        totalConsumptionDistributed += consumptiondistributed;
        totalConsumptionShared += consumptionshared;
        totalConsumptionTotal += consumptiontotal;

        return {
            assetid: asset.id,
            type: type,
            distributetoshares: distributetoshares,
            name: name,
            clientid: clientid,
            share: share,
            before: before,
            after: after,
            usage: usage,
            consumptiondistributed: parseFloat(consumptiondistributed.toFixed(2)),
            consumptionshared: parseFloat(consumptionshared.toFixed(2)),
            consumptiontotal: parseFloat(consumptiontotal.toFixed(2)),
        };
    });

    result = {
        meters: metersResult,
        totalshares: parseFloat(totalShares.toFixed(2)),
        totalbefore: parseFloat(totalBefore.toFixed(2)),
        totalafter: parseFloat(totalAfter.toFixed(2)),
        totalusage: parseFloat(totalUsage.toFixed(2)),
        totalusageinput: parseFloat(totalUsageInput.toFixed(2)),
        totalusageoutput: parseFloat(totalUsageOutput.toFixed(2)),
        totalimbalance: totalImabalance,
        totalusagetobedistributed: parseFloat(totalUsageToBeDistributed.toFixed(2)),
        totalconsumptiondistributed: parseFloat(totalConsumptionDistributed.toFixed(2)),
        totalconsumptionshared: parseFloat(totalConsumptionShared.toFixed(2)),
        totalconsumptiontotal: parseFloat(totalConsumptionTotal.toFixed(2)),
    }

    return result;
}

export function getlastreading(readings, assetid) {
    let lastassetreading = { ts: 0, reading: 0 };

    const readingsForAsset = readings
        .filter(r => r.rows.some(row => row.assetid === assetid))
        .sort((a, b) => a.ts - b.ts);

    if (readingsForAsset.length === 0)
        return lastassetreading;

    const lastReading = readingsForAsset[readingsForAsset.length - 1];

    const assetRow = lastReading.rows.find(row => row.assetid === assetid);

    if (assetRow) {
        lastassetreading.ts = lastReading.ts;
        lastassetreading.reading = parseFloat(assetRow.reading);
    }

    return lastassetreading;
}